import { fork } from 'redux-saga/effects';
import watchHoverOnTrip from './watchHoverOnTrip';
import watchToggleMap from './watchToggleMap';


export default function* srpMap() {
  yield fork(watchHoverOnTrip);
  yield fork(watchToggleMap);
}
